'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./BlockRevealAnimation.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlockRevealAnimation = function BlockRevealAnimation(_ref) {
  var delay = _ref.delay,
      duration = _ref.duration,
      className = _ref.className,
      children = _ref.children,
      color = _ref.color;
  return _react2.default.createElement(
    'span',
    { className: 'block-reveal-animation ' + className },
    _react2.default.createElement(
      'div',
      {
        className: 'block-reveal-animation__element',
        style: {
          animationDelay: delay + duration / 2 + 's'
        } },
      children
    ),
    _react2.default.createElement('span', {
      className: 'block-reveal-animation__block',
      style: {
        animationDelay: delay + 's',
        animationDuration: duration + 's',
        backgroundColor: color
      }
    })
  );
};

BlockRevealAnimation.propTypes = {
  children: _propTypes2.default.node.isRequired,
  color: _propTypes2.default.string,
  className: _propTypes2.default.string,
  delay: _propTypes2.default.number,
  duration: _propTypes2.default.number
};

BlockRevealAnimation.defaultProps = {
  className: '',
  delay: 1,
  duration: 0.9,
  color: '#000'
};

exports.default = BlockRevealAnimation;